import { z } from 'zod';
import { AccessTokenExpiredReasonSchema } from '../inputTypeSchemas/AccessTokenExpiredReasonSchema'

/////////////////////////////////////////
// ACCESS TOKEN SCHEMA
/////////////////////////////////////////

export const AccessTokenSchema = z.object({
  expired_reason: AccessTokenExpiredReasonSchema.nullable(),
  id: z.bigint(),
  city_id: z.number().int(),
  refresh_token_id: z.bigint(),
  created_at: z.coerce.date(),
  expired_at: z.coerce.date().nullable(),
})

export type AccessToken = z.infer<typeof AccessTokenSchema>

export default AccessTokenSchema;
